// 会场管理 Vuex 模块 - 独立模块，记录会场管理相关数据（含登录），与其他模块互不影响
import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters
}
